
// vue
import { ref, defineComponent } from 'vue';

// atoms
import CustomButton from '@/components/atoms/CustomButton.vue';
import Heading from '@/components/atoms/Heading.vue';
import RetinaImg from '@/components/atoms/RetinaImg.vue';
// molecules
// organisims
import TopCreateRoomWindow from '@/components/organisms/TopCreateRoomWindow.vue';
import TopHowToUse from '@/components/organisms/TopHowToUse.vue';
import TopIssue from '@/components/organisms/TopIssue.vue';
import TopCard from '@/components/organisms/TopCard.vue';
import TopSolution from '@/components/organisms/TopSolution.vue';

export default defineComponent({
  name: 'Top',
  components: {
    CustomButton,
    Heading,
    RetinaImg,
    TopCreateRoomWindow,
    TopHowToUse,
    TopIssue,
    TopCard,
    TopSolution,
  },
  setup() {
    const isModalOpen = ref(false);

    return {
      isModalOpen,
    };
  },
});
